import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { Contacts } from '../../../model/contacts';
import { Groups } from '../../../model/groups';
import { StorageService } from '../../../service/managers/storage.service';
import { GroupsService } from '../../../service/component_dependent/groups.service';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { ContactGroupService } from '../../../service/component_dependent/contacts/contact-group.service';
import { ContactGroup } from '../../../model/contact-group';
import { JsonManager } from '../../../service/managers/json-manager';

@Component({
  selector: 'app-groups-profile',
  templateUrl: './groups-profile.component.html',
  styleUrls: ['./groups-profile.component.scss']
})
export class GroupsProfileComponent implements OnInit {

  @ViewChild('modal') private modal: ElementRef;

  @Output() onCreated: EventEmitter<void> = new EventEmitter<void>();

  protected dropdownSettings = {};
  protected cDropdownList = [];
  protected contactList = [];

  private init = [];

  protected loading: boolean = true;

  protected mode: string;

  group: Groups;

  constructor(private modalService: NgbModal,
    private contactsService: ContactsService,
    private storageService: StorageService,
    private groupsService: GroupsService,
    private notifierService: NotifierService,
    private contactGroupService: ContactGroupService) {

  }

  ngOnInit() {
    this.dropdownSettings = {
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

  }

  public open() {
    this.mode = "create";
    this.clear();
    this.modalService.open(this.modal, { ariaLabelledBy: 'groupsTitle', size: 'lg' });
    this.initComponents();
  }

  public edit(group: Groups) {
    this.mode = "edit";
    this.clear();
    this.modalService.open(this.modal, { ariaLabelledBy: 'groupsTitle', size: 'lg' });
    this.initComponentsEdit(group);
  }

  protected onSubmit() {

    let reqObj: any;
    let arrCG = [];

    for (var i = 0; i < this.contactList.length; i++) {
      arrCG.push(this.contactList[i].item_id);
    }

    reqObj = this.group;
    reqObj.contact_group = arrCG;

    switch (this.mode) {
      case "create": {
        this.groupsService.createGroup(reqObj).subscribe(
          (dataGroup: any) => {
            this.notifierService.showSuccess(dataGroup.message);
          },
          (errorGroup: any) => {
            this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errorGroup.error));
          }
        );
        break;
      }

      case "edit": {
        this.groupsService.updateGroup(reqObj).subscribe(
          (dataGroup: any) => {
            this.notifierService.showSuccess(dataGroup.message);
          },
          (errorGroup: any) => {
            this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errorGroup.error));
          }
        );
        break;
      }
    }
  }

  protected onFilterChange(keyword: string) {
    this.contactsService.getContactsOrGroups(keyword).subscribe(
      (dataContacts: any) => {
        this.reassignVariablesContacts(dataContacts);
      },
      (errContacts: any) => {
        
      }
    );
  }

  private reassignVariablesContacts(data: any) {
    this.cDropdownList = [];

    for (var i = 0; i < data.length; i++) {
      if(data[i].source == "contacts"){
        this.cDropdownList.push({ item_id: data[i].id, item_text: (data[i].name)});
        this.init.push({ item_id: data[i].id, item_text: (data[i].name)});
      }
    }

    if(data.length == 0){
      this.cDropdownList = this.init;
    }
  }

  private initComponents() {
    this.loading = true;
    this.group = new Groups();
    this.group.is_deleted = 0;
    this.group.added_by = this.storageService.getUser().id;
    this.loading = false;
  }

  private initComponentsEdit(data: any) {
    let id;

    id = data.id;
    this.loading = true;

    this.groupsService.getGroup(id).subscribe(
      (dataGroup: any) => {
        this.group = dataGroup.data;
      },
      (errGroup: any) => {
      }
    );

    this.contactsService.getContactsByGroupID(id).subscribe(
      (dataContact: any) => {
        let data;

        data = dataContact.data;
        
        for (var i = 0; i < data.length; i++) {
          this.contactList.push({ item_id: data[i].id, item_text: (data[i].first_name + " " + data[i].last_name) });
          this.cDropdownList.push({ item_id: data[i].id, item_text: (data[i].first_name + " " + data[i].last_name) });
        }
        this.loading = false;
      },
      (errContact: any) => {
        this.loading = false;
      },
    );
  }

  private clear() {
    this.contactsService.getContactsOrGroups('').subscribe(
      (dataContacts: any) => {
        this.reassignVariablesContacts(dataContacts);
      },
      (errContacts: any) => {
      }
    );
    this.contactList = [];
    this.group = new Groups();
  }

}
